import { jsxs as c, jsx as r } from "react/jsx-runtime";
import { forwardRef as y } from "react";
function m(a) {
  switch (a) {
    case "info":
      return {
        haloBg: "var(--info-bg)",
        haloBorder: "var(--info-border)",
        haloFg: "var(--info)"
      };
    case "success":
      return {
        haloBg: "var(--success-bg)",
        haloBorder: "var(--success-border)",
        haloFg: "var(--success)"
      };
    case "error":
      return {
        haloBg: "var(--error-bg)",
        haloBorder: "var(--error-border)",
        haloFg: "var(--error)"
      };
    case "accent":
      return {
        haloBg: "var(--accent-dim)",
        haloBorder: "var(--accent-border)",
        haloFg: "var(--accent-default)"
      };
    case "warning":
      return {
        haloBg: "var(--warning-bg)",
        haloBorder: "var(--warning-border)",
        haloFg: "var(--warning)"
      };
    case "neutral":
    default:
      return {
        haloBg: "var(--overlay-low)",
        haloBorder: "var(--border-subtle)",
        haloFg: "var(--text-secondary)"
      };
  }
}
function b(a) {
  switch (a) {
    case "sm":
      return {
        pad: "var(--space-4)",
        haloSize: "40px",
        titleSize: "var(--text-md)",
        titleLine: "var(--line-md)",
        bodySize: "var(--text-sm)",
        gap: "var(--space-2)"
      };
    case "lg":
      return {
        pad: "var(--space-8)",
        haloSize: "88px",
        titleSize: "var(--text-xl)",
        titleLine: "var(--line-xl)",
        bodySize: "var(--text-md)",
        gap: "var(--space-4)"
      };
    case "md":
    default:
      return {
        pad: "var(--space-6)",
        haloSize: "64px",
        titleSize: "var(--text-lg)",
        titleLine: "var(--line-lg)",
        bodySize: "var(--text-sm)",
        gap: "var(--space-3)"
      };
  }
}
const S = {
  // ls-pulse keyframe is defined in tokens.css §6.3 and clamped to 0 duration
  // when [data-motion=reduce] — accessibility.md §5.
  position: "absolute",
  inset: 0,
  borderRadius: "inherit",
  background: "currentColor",
  opacity: 0.2,
  animation: "ls-pulse var(--duration-pulse) var(--ease-in-out) infinite",
  pointerEvents: "none"
}, F = y(function({
  media: o,
  title: v,
  description: i,
  action: l,
  tone: n = "neutral",
  size: s = "md",
  iconPulse: h = !1,
  live: d = !1,
  style: u,
  ...g
}, p) {
  const t = m(n), e = b(s), f = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: e.gap,
    padding: e.pad,
    textAlign: "center",
    color: "var(--text-primary)",
    fontFamily: "var(--font-sans)",
    ...u
  }, x = {
    position: "relative",
    width: e.haloSize,
    height: e.haloSize,
    borderRadius: "var(--radius-full)",
    background: t.haloBg,
    border: `1px solid ${t.haloBorder}`,
    color: t.haloFg,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flex: "0 0 auto"
  };
  return /* @__PURE__ */ c(
    "div",
    {
      ref: p,
      role: d ? "status" : void 0,
      "aria-live": d ? "polite" : void 0,
      "data-tone": n,
      "data-size": s,
      style: f,
      ...g,
      children: [
        o !== void 0 ? /* @__PURE__ */ c("div", { style: x, "aria-hidden": !0, children: [
          h ? /* @__PURE__ */ r("span", { style: S }) : null,
          /* @__PURE__ */ r("span", { style: { position: "relative", display: "inline-flex", color: t.haloFg }, children: o })
        ] }) : null,
        /* @__PURE__ */ r(
          "div",
          {
            style: {
              fontSize: e.titleSize,
              lineHeight: e.titleLine,
              fontWeight: "var(--font-weight-semibold)",
              color: "var(--text-primary)",
              maxWidth: "420px"
            },
            children: v
          }
        ),
        i ? /* @__PURE__ */ r(
          "div",
          {
            style: {
              fontSize: e.bodySize,
              lineHeight: "var(--line-sm)",
              color: "var(--text-secondary)",
              maxWidth: "480px"
            },
            children: i
          }
        ) : null,
        l ? /* @__PURE__ */ r("div", { style: { marginTop: "var(--space-2)" }, children: l }) : null
      ]
    }
  );
});
export {
  F as E
};
//# sourceMappingURL=EmptyState-CsnOG9HB.js.map
